import React from 'react'
import { LogoTransfix } from 'transfix-ui/components/LogoTransfix'
import { Box, Typography } from 'transfix-ui/core'
import { FP_SUPPORT_EMAIL } from 'apps/fleet-planner/config/constants'

export const InvalidInviteLink = () => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      alignSelf='center'
      maxWidth='500px'
      textAlign='center'
      p={2}>
      <Box mt={6} mb={3}>
        <LogoTransfix color='black' />
      </Box>
      <Typography variant='h3'>Sorry, something is wrong with this link.</Typography>
      <Box my={3}>
        We were unable to finish registering your account using this invitation link.{' '}
        <a
          style={{ display: 'inline' }}
          href={`mailto:${FP_SUPPORT_EMAIL}?subject=Problems logging into FMS using my invite link (invalid token)`}>
          Please contact our support team
        </a>
        , they will be happy to help.
      </Box>
    </Box>
  )
}
